<odx-form-field i18n-label="@@newProject.projectForm.label.forzaId" label="Forza-ID" [readonly]="!isWriteable()">
  <input
    formControlName="forzaId"
    odxFormFieldControl
    i18n-placeholder="@@newProject.projectForm.placeholder.forzaId"
    placeholder="Forza-ID"
    [readonly]="isReadonly"
    [required]="required"
    data-testid="projectForm.forzaId"
  />

  <ng-template odxFormFieldError="pattern" i18n="@@newProject.projectForm.patternError.forzaId"
    >Ungültige FORZA-ID (Beispiel: 13561)</ng-template
  >
</odx-form-field>
